import DownloadIcon from '@mui/icons-material/Download';

import { ActionButton } from 'commonComponents/ActionButton';

import { useDownloadCertificate } from 'api/licenses';
import { ROLE_DEFINITIONS } from 'roles/definitions';
import { RoleDependentComponent } from 'roles/RoleDependentComponent';

export function DownloadCertificateButton({ licenseDetails }) {
    const { invalidated, license_key, licenseFilesCount } = licenseDetails;
    const { mutate: downloadCertificate, isPending: isLoading } = useDownloadCertificate();

    if (invalidated || licenseFilesCount === 0 || !licenseDetails.configuration.product.has_certificate_template) {
        return null;
    }

    const handleDownloadClick = () => {
        if (license_key) {
            downloadCertificate(license_key);
        }
    };

    return (
        <RoleDependentComponent
            userRole={ROLE_DEFINITIONS.PrivilegedCustomer}
            component={ActionButton}
            onClick={handleDownloadClick}
            disabled={isLoading}
            color="secondary"
            iconClass={DownloadIcon}
            title={isLoading ? 'Downloading...' : 'Download Certificate'}
            variant="contained"
        />
    );
}
